import React, { Dispatch, SetStateAction, useState } from "react";
import { VerificationStatusFilter } from "../../types/enums";
import Modal from "react-modal";
import {
  HorizontalContainer,
  HorizontalLeftAlignedContainer,
  HorizontalSpaceBetweenContainer,
} from "../../styles/container";
import { H2 } from "../../styles/text";
import { FilterToggleButton } from "../../components/buttons/FilterToggleButton";
import { FilterButton } from "../../components/buttons/FilterButton";
import { enumValues } from "../../types/utils";
import { COLORS } from "../../styles/colors";
import { TextButton } from "../../components/buttons/TextButton";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { getBorderRadius } from "../../utils";
import { SECTION_VERTICAL_SPACING } from "../../styles/spacing";
import { customStyles } from "./constants";

type VerificationStatusFilterButtonProps = {
  value: VerificationStatusFilter;
  setValue: Dispatch<SetStateAction<VerificationStatusFilter>>;
  defaultValue: VerificationStatusFilter;
};

export const VerificationStatusFilterButton = (
  props: VerificationStatusFilterButtonProps
) => {
  const { value, setValue, defaultValue } = props;
  const colors = COLORS["light"];

  const [localValue, setLocalValue] = useState(defaultValue);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  // const customStyles = {
  //   content: {
  //     top: "50%",
  //     left: "50%",
  //     right: "auto",
  //     bottom: "auto",
  //     marginRight: "-50%",
  //     transform: "translate(-50%, -50%)",
  //     borderRadius: getBorderRadius("medium", "rounded rect"),
  //   },
  //   overlay: {
  //     zIndex: 1000,
  //   },
  // };

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleClick = () => {
    openModal();
  };

  const handleSelect = () => {
    setValue(localValue);
    closeModal();
    // clear location?
  };

  const handleCancel = () => {
    closeModal();
  };

  const handleReset = () => {
    setLocalValue(defaultValue);
  };

  return (
    <>
      <FilterButton
        title={value === VerificationStatusFilter.Any ? "Status" : value}
        onClick={handleClick}
        active={value !== VerificationStatusFilter.Any}
        iconName={
          value !== VerificationStatusFilter.Unverified
            ? "checkmark-circle-outline"
            : "ellipse-outline"
        }
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
        appElement={document.getElementById("root") as HTMLElement}
      >
        <div
          style={{
            flex: 1,
          }}
        >
          <HorizontalSpaceBetweenContainer style={{ marginBottom: 24 }}>
            <H2>Verification Status</H2>
            <TextButton
              title="Reset"
              onClick={() => handleReset()}
              color={colors.PRIMARY_BRAND}
            />
          </HorizontalSpaceBetweenContainer>

          <HorizontalLeftAlignedContainer
            style={{ width: 320, paddingBottom: SECTION_VERTICAL_SPACING }}
          >
            {enumValues(VerificationStatusFilter).map((buttonValue, index) => {
              return (
                <FilterToggleButton
                  key={index}
                  title={buttonValue}
                  onClick={() => setLocalValue(buttonValue)}
                  selected={localValue === buttonValue}
                />
              );
            })}
          </HorizontalLeftAlignedContainer>
          <HorizontalContainer>
            <PrimaryButton
              flex={1}
              onClick={handleSelect}
              type="button"
              title="Apply"
            />
          </HorizontalContainer>
        </div>
      </Modal>
    </>
  );
};
